import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import { getRentContractId, Translation as T } from "@awe-web/shared/lib";
import { TypeArea } from "../../../components/layout.js";
import { Row, Col } from "../../../components/grid.js";
import { Button } from "../../../components/form.js";
import { ScreenSection, ScreenHeading } from "../../../components/screen.js";
import { TextLinkList } from "../../../components/text_link_list.js";
import LoginForm from "../../../user/components/login_form";
import { login } from "../../../user/actions.js";
import { B2B_RequestResetPasswordToken, B2B_SignUpRequest, B2C_Login } from "../../../routing/routes.js";
import { useInitialize } from "../../../util/react.js";
import { initialize } from "./actions.js";

import "./login.scss";

const HEADING = "ALG0000191";
const INTRODUCTION = "ALG0000192";
const LINK_RECOVER_PASSWORD = "ALG0000193";
const LINK_SIGN_UP = "ALG0000194";
const LINK_B2C_LOGIN = "ALG0000216";

export default function B2B_Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const rentContractId = useSelector((state) => getRentContractId(state));

  const [captchaToken, setCaptchaToken] = useState();

  const onSubmit = useCallback(async ({ username, password }) => {
    const redirectPath = await dispatch(login({ username, password, rentContractId, captchaToken }));
    const finalRedirectPath = location.state?.from?.pathname ? location.state?.from?.pathname : redirectPath;
    if (redirectPath && finalRedirectPath && finalRedirectPath.length > 0) {
      navigate(finalRedirectPath, { replace: true });
    }
  }, [dispatch, location?.state?.from?.pathname, navigate, rentContractId, captchaToken]);

  const onCaptchaChange = useCallback((captchaToken) => {
    setCaptchaToken(captchaToken);
  }, []);

  const init = useCallback(async () => {
    const redirectPath = await dispatch(initialize());

    if (redirectPath && redirectPath.length > 0) {
      navigate(redirectPath);
    }
  }, [dispatch, navigate]);

  const isReady = useInitialize(init);
  const className = classnames("b2b-login", { "b2b-login--ready": isReady });

  return (
    <div className={className}>
      <ScreenSection main dark>
        <TypeArea>
          <Row>
            <Col
              tablet={{ cols: 4, offset: 2 }}
              desktop={{ cols: 4, offset: 4 }}
            >
              <ScreenHeading>
                <T code={HEADING} />
              </ScreenHeading>

              <p>
                <T code={LINK_B2C_LOGIN} to={B2C_Login.location()} />
              </p>

              <p className="b2b-login__introduction">
                <T code={INTRODUCTION} />
              </p>

              <LoginForm
                onSubmit={onSubmit}
                rentContractId={rentContractId}
                onCaptchaChange={onCaptchaChange}
              />

              <TextLinkList>
                <Button tertiary to={B2B_RequestResetPasswordToken.path()}>
                  <T code={LINK_RECOVER_PASSWORD} />
                </Button>
                <Button tertiary to={B2B_SignUpRequest.location()}>
                  <T code={LINK_SIGN_UP} />
                </Button>
              </TextLinkList>
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
